<template>
  <router-view />
</template>

<style>
@import url("bulma/css/bulma.min.css");
</style>
